<template>
  <Layout>
    <PageHeader :title="title" :items="items" />

    <div class="row">
      <div class="col-12">
        <div class="card">
          <div class="card-body">
            <div class="row mb-2">
              <div class="col-sm-12 col-md-6">
                <div id="tickets-table_length" class="dataTables_length">
                  <b-button class="btn btn-success" :to="{ name: 'orders-create' }">Add Order</b-button>
                  <!-- <label class="d-inline-flex align-items-center">
                    Show&nbsp;
                    <b-form-select
                        class="form-select form-select-sm"
                        v-model="perPage"
                        size="sm"
                        :options="pageOptions"
                    ></b-form-select
                    >&nbsp;entries
                  </label>-->
                </div>
              </div>
              <!-- Search -->
              <div class="col-sm-12 col-md-6">
                <div
                    id="tickets-table_filter"
                    class="dataTables_filter text-md-end"
                >
                  <label class="d-inline-flex align-items-center">
                    Search:
                    <b-form-input
                        v-model="filter"
                        type="search"
                        placeholder="Search..."
                        class="form-control form-control-sm ms-2"
                    ></b-form-input>
                  </label>
                </div>
              </div>
              <!-- End search -->
            </div>
            <!-- Table -->
            <div class="table-responsive mb-0">
              <b-table
                  class="datatables"
                  :items="orders"
                  :fields="fields"
                  responsive="sm"
                  :per-page="perPage"
                  :current-page="currentPage"
                  :sort-by.sync="sortBy"
                  :sort-desc.sync="sortDesc"
                  :filter="filter"
                  :filter-included-fields="filterOn"
                  @filtered="onFiltered"
                  @row-clicked="editOrder"
              >
                <template v-slot:cell(count)="row">
                  {{ row.item.amount }}/{{ row.item.capacity || 0 }}/{{ row.item.tickets.length }}
                </template>
                <template v-slot:cell(company)="row">
                  <h5 class="text-truncate font-size-14 mb-0">{{ row.item.firstname }} {{ row.item.name }}</h5><p class="text-muted mb-0">{{ row.item.company }}</p>
                </template>
                <template v-slot:cell(status)="row">

                  <b-badge class="" :class="{
                    'badge-soft-success': row.item.status == 'SHIPPED',
                    'badge-soft-warning': row.item.status == 'ORDERED',
                    'badge-soft-pink': row.item.status == 'READY',
                    'badge-soft-info': row.item.status == 'CREATED',
                  }">{{row.item.status}}</b-badge>
                </template>
                <template v-slot:cell(orderDate)="row">
                  {{ row.item.orderDate | formatDate }} <template v-if="row.item.seenDate">(seen)</template>
                </template>
                <template v-slot:cell(actions)="row">
                  <a
                      @click="shipOrder(row.item)"
                      class="btn btn-danger waves-effect waves-light me-1"
                  ><i class="fa fa-shipping-fast"></i
                  > Verschicken</a> <a
                    @click="ticketsOrder(row.item)"
                    class="btn btn-success waves-effect waves-light me-1"
                ><i class="fa fa-ticket-alt"></i
                > Tickets</a>
                  <a
                      @click="editOrder(row.item)"
                      class="btn btn-warning waves-effect waves-light me-1"
                  ><i class="fa fa-edit"></i
                  > Edit</a>
                </template>
              </b-table>
            </div>
            <div class="row">
              <div class="col">
                <div
                    class="dataTables_paginate paging_simple_numbers float-end"
                >
                  <ul class="pagination pagination-rounded mb-0">
                    <!-- pagination
                    <b-pagination
                        v-model="currentPage"
                        :total-rows="rows"
                        :per-page="perPage"
                    ></b-pagination>-->
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </Layout>
</template>

<script>
import Repository from "@/repositories/RepositoryFactory";
const OrderRepository = Repository.get("orders");

import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
/**
 * Ticket Orders Component
 */
export default {
  page: {
    title: "Ticket Orders",
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
  components: {
    Layout,
    PageHeader,
  },
  data() {
    return {
      orders: [],
      title: "Ticket Orders",
      items: [
        {
          text: "Ticket Orders",
          href: "/orders",
        },
        {
          text: "Default",
          active: true,
        },
      ],
      statData: [

      ],
      totalRows: 1,
      currentPage: 1,
      perPage: 10000,
      //pageOptions: [10, 25, 50, 100],
      filter: null,
      filterOn: [],
      sortBy: "company",
      sortDesc: false,
      fields: [
        {
          key: "company",
          sortable: true,
        },
        {
          key: "count",
          sortable: true,
        },
        {
          key: "status",
          sortable: true,
        },
        {
          key: "orderDate",
          sortable: true,
        },
        /*{
          key: "comments",
          sortable: true,
        },*/
        {
          key: "actions",
          sortable: false,
        },
      ],
      tableData: [],
    };
  },
  computed: {
    /**
     * Total no. of records
     */
    rows() {
      return this.tableData.length;
    },
  },
  created() {
    this.getOrders();
  },
  mounted() {
    // Set the initial number of items
    this.totalRows = this.tableData.length;
  },
  methods: {
    getOrders: async function() {
      const { data } = await OrderRepository.getAll();
      this.orders = data;
    },
    // eslint-disable-next-line no-unused-vars
    shipOrder(item){
      // open Details page
      this.$router.push({ name: 'orders-shipping-id', params: { id: item.id } })
    },
    editOrder(item){
      // open Details page
      this.$router.push({ name: 'orders-id', params: { id: item.id } })
    },
    // eslint-disable-next-line no-unused-vars
    ticketsOrder(item){
      // open Details page
      this.$router.push({ name: 'orders-seatmap-id', params: { id: item.id } })
    },
    /**
     * Search the table data with search input
     */
    onFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    },
  },
};
</script>